











import { Component, Mixins } from 'vue-property-decorator';
import { Component as LoadingSpinner } from '@/components/spinners';
import { Warning, Info } from '@/pages/profile/components';
import Infotext from '@/components/parts/infotext';
import ViewsProps from '@/pages/profile/modules/remote-edu/mixins/viewsProps';
import { Top } from '../components';

@Component({
  components: {
    Top,
    LoadingSpinner,
    Infotext,
    Warning,
    Info,
  },
})
export default class Lessons extends Mixins(ViewsProps) {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/lessons/Lessons.vue